<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">카카오페이</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">결제금액</span>
        <div class="ip-row">
          <label for="payAmount">결제금액</label>
          <input
            type="text"
            class="ip-comm"
            id="kakaoPayAmount"
            :value="
              (kakaoTotalUprc > 0
                ? kakaoTotalUprc
                : complexUprc > 0
                ? complexUprc
                : totalCash
              )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "

          />
        </div>
      </div>
      <div class="fieldset">
        <span class="h2">결제입력</span>
        <div class="ip-row">
          <label for="payNum">번호</label>
          <input
            type="text"
            class="ip-comm center"
            id="payNum"
            value="2961 2345 7757 2222 7998 7923"
          />
        </div>
        <div class="ip-row col05">
          <!-- label for="payClass">구분</label>
          <input type="text" class="ip-comm center" id="payClass" value="" /-->
          <label for="payInst">할부개월</label>
          <input type="text" class="ip-comm center" id="payInst" value="" />
        </div>
      </div>
      <div class="fieldset">
        <span class="h2">서명</span>
        <div class="ip-row">
          <canvas id="" class="sign-area"></canvas>
          <button type="button" class="btn-2xlg btn-yellow" @click="payInKaKao">
            승인요청<span class="overlay"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "kakaoPay",
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
    payType: String,
    isComplex: Boolean,
    kakaoTotalUprc: Number,
    complexUprc: Number,
  },
  data() {
    return {
      totalCash: this.totalUprc - this.totalDiscount - this.receivedUprc,
    };
  },
  methods: {
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    async payInKaKao() {
      let kakaoPayAmount = parseInt(document.getElementById("kakaoPayAmount").value.replace(",",""));
      if (this.isComplex) {
        this.$.emit("close");
        this.$.emit("closeComplexKakao", kakaoPayAmount);
        this.$.emit("addComplexPayArr", kakaoPayAmount, 'kakao');
      } else {
        await this.loadingPromise("카카오페이 조회 중입니다.");
        await this.loadingPromise("결제완료 처리 중입니다.");
        await this.loadingPromise("영수증 출력 중입니다.");
        this.$.emit("resetBasket", this.payType);
        this.$.emit("close");
      }
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>
